import React, { useState, useCallback } from 'react';
import { translations } from './translations';

const LanguageContext = React.createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('amg_lang') || 'en');

  const switchLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem('amg_lang', l);
  }, []);

  const t = useCallback((path) => {
    const keys = path.split('.');
    let val = translations[lang];
    for (const k of keys) {
      if (val === undefined) return path;
      val = val[k];
    }
    return val !== undefined ? val : path;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, switchLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = React.useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be inside LanguageProvider');
  return ctx;
};

export default LanguageContext;
